import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData, getInputParams, currencyFormatter } from '../CustomUtils'
import { INVOICE_DETAIL_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ReportGrid from '../ReportGrid.js'
import { getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ReportTotalsRow from '../ReportTotalsRow.js'

const INVOICE_DETAIL_REPORT = gql(INVOICE_DETAIL_REPORT_QUERY)

export default function InvoiceDetailReport({ location }) {
  console.log('InvoiceDetailReport rendered:', location)

  const inputs = getInputParams(location)
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, INVOICE_DETAIL_REPORT, 'invoiceDetailReport', setResults, setGraphQLErrors)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/Asbestos/invoiceDetailReport/invoice_detail.csv?inputs=${JSON.stringify(inputs)}`
    const totalColumns = [
      { columnNumber: 4 },
      { columnNumber: 5 },
      { columnNumber: 6 }
    ]
    const columnFormatters = [
      { columnNumber: 4, formatter: currencyFormatter().format, align: 'right' },
      { columnNumber: 5, formatter: currencyFormatter().format, align: 'right' },
      { columnNumber: 6, formatter: currencyFormatter().format, align: 'right' },
    ]
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '900px', margin: 'auto'}} >
          <ReportHeading title='Invoice Detail Report' parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} columnFormatters={columnFormatters} />
            <ReportTotalsRow reportData={results.reportData} totalColumns={totalColumns} />
          </tbody>
        </Table>
      </div>
    )
  }
}